import axios from 'axios';
import { EmployeeGetAllQuery } from '../../types';

interface CreateEmployeeProps {
  companyId: string;
  companyType: 'YardCompany' | 'Yard' | 'Client';
  email: string;
  employeeRole:
    | 'Admin'
    | 'Employee'
    | 'Viewer'
    | 'Manager'
    | 'Dispatcher'
    | 'CompanyAdmin'
    | 'CompanyEmployee';
  firstName: string;
  lastName: string;
  password: string;
  passwordConfirm: string;
  phoneNumber: string;
  [x: string]: any;
}

export interface UpdateStatusProps {
  userId: string;
  status?: string;
  METHOD?: 'patch' | 'post';
}

interface UpdateStatusRequiredProps extends UpdateStatusProps {
  METHOD: 'patch' | 'post';
}

export interface UpdateYardEmployeeProps {
  userId: string;
  canCreateClient: boolean;
}

const getAllEmployeesLink: any = {
  YardCompany: '/yard-company-employees',
  Yard: '/yard-employees',
  Client: '/client-employees',
};

class EmployeesService {
  getAll = ({ belongsTo, ...data }: any) =>
    axios.get<EmployeeGetAllQuery>(`${getAllEmployeesLink[belongsTo]}`, {
      ...data,
    });

  getAllYardOptions = (yardId: string) => {
    if (!yardId) return Promise.resolve([]);

    return axios
      .get<EmployeeGetAllQuery>('/yard-employees', {
        params: {
          notLoading: true,
          accountStatus: 'ACTIVE',
          short: true,
          yardId,
        },
      })
      .then((res) => {
        return res.data.data.map((item: any) => ({
          label: item.user.firstName + ' ' + item.user.lastName,
          value: item.user.id,
          id: item.user.id,
        }));
      });
  };

  create = ({
    companyType,
    email,
    employeeRole,
    firstName,
    lastName,
    password,
    passwordConfirm,
    phoneNumber,
    employeeRequestLink,
    ...props
  }: CreateEmployeeProps) =>
    axios.post(`${employeeRequestLink}`, {
      ...props,
      firstName,
      lastName,
      password,
      passwordConfirmation: passwordConfirm,
      email,
      phoneNumber,
      role: companyType + employeeRole,
    });

  updateStatus = async ({ userId, status, METHOD }: UpdateStatusRequiredProps) => {
    return axios[METHOD](`/users/${status}`, {
      userId,
    });
  };

  udpateYardEmployee = async ({ userId, canCreateClient }: UpdateYardEmployeeProps) => {
    return axios.patch(`/users/${userId}/yard-employee`, { canCreateClient });
  };
}

export const employeesService = new EmployeesService();
